import PropTypes from "prop-types";

import styled, { StyleSheetManager, ThemeProvider } from "styled-components";
import theme from "theme";

import FnrButton from "UI/FnrButton3";
import FnrErrorBoundaryError from "UI/FnrErrorBoundaryError";
import FnrTypography from "UI/FnrTypography";
import { colors } from "UI/colors";
import UnoWalking from "UI/images/UnoWalking";

import { shouldForwardProp } from "./Providers";

AppCrashFallback.propTypes = {
  /** From the error boundary; only shown in dev */
  error: PropTypes.object,
};

/**
 * What people see when the whole app crashes, instead of a blank page.
 *
 * Brings its own theme because RootErrorBoundary renders this outside Providers.
 * Sits on its own card since the page behind it can be any color.
 */
export default function AppCrashFallback({ error }) {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ThemeProvider theme={theme}>
        <Card role="alert">
          <UnoWalking color="lightBlue" size={120} />
          <FnrTypography type="header" fontSize="xl" color="primary">
            Oops, this page hit a snag.
          </FnrTypography>
          <FnrButton
            color="blue"
            size="large"
            onClick={() => window.location.reload()}
          >
            Reload page
          </FnrButton>
          <FnrErrorBoundaryError error={error} />
        </Card>
      </ThemeProvider>
    </StyleSheetManager>
  );
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 420px;
  margin: 80px auto;
  padding: 32px 24px;
  border-radius: 16px;
  background: ${colors.white};
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.3);
  text-align: center;
  text-wrap: balance;

  button {
    margin-top: 8px;
    font-family: inherit;
  }
`;
